import floorApi from "@/api/floorApi";
import FloorArea from "./floorArea";

export interface IFloorPlan {
  id: string;
  name: string;
  background_image_id?: string;
  background: any;
  svg: any;
  svg_image_id?: string;
  svg_object: any;
  areas: FloorArea[];
  total_property_used?: number;
}
export class FloorPlanDTO implements IFloorPlan {
  id: string;
  name: string;
  background_image_id?: string;
  svg_image_id?: string;
  background: any;
  svg: any;
  svg_object: any;
  areas: FloorArea[];
  total_property_used?: number;
}

export default class FloorPlan extends FloorPlanDTO {
  constructor(dto?: FloorPlanDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      name: "",
      background_image_id: null,
      svg: {},
      svg_image_id: null,
      background: null,
      svg_object: {},
      areas: [],
    });
  }

  public save() {
    if (this.id) {
      return floorApi.update(this);
    } else {
      return floorApi.create(this);
    }
  }

  public delete() {
    return floorApi.delete(this.id);
  }
}
